<template>
  <div class="my-notify-dialog">
    <!-- 自绘遮罩：Element 的 v-modal 挂在 body，而本组件处于 .pad transform 画布
         （层叠上下文），画布内任何 z-index 都压不过 body 下的 v-modal——遮罩会盖住
         弹窗按钮（重新打印/返回首页）导致点不到。禁用自带 modal，遮罩画在画布内 -->
    <div class="notify-mask" v-show="isShow"></div>
    <el-dialog :visible.sync="isShow" :title="title" width="60%" :show-close="false"
               :modal="false" :before-close="handleClose" center @close="dialogClose">
      <div class="dialog-sign">
        <el-image v-if="success" :src="require('@/assets/success.png')"
                  style="width: 200px; height: 200px"></el-image>
        <el-image v-else :src="require('@/assets/false.png')" style="width: 200px; height: 200px"></el-image>
        <div style="margin: 10px; font-size: 18px; text-align: center" v-html="msg"></div>
      </div>
      <div v-if="this.success" style="width: 100%; text-align: center">
        <el-button v-if="reprint" @click="doReprintData" type="primary">重新打印</el-button>
        <el-button @click="clickBackHome" type="success">返回首页（倒计时 {{ countDown }} 秒）</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MyNotifyDialog",
  props: {
    show: {type: Boolean,},
    success: {type: Boolean,},
    title: {type: String,},
    msg: {type: String,},
    reprint: {type: Boolean, default: false},
    rePrintData: {
      type: Function, default: () => {
      }
    },
  },
  data() {
    return {
      countDown: 0,
      isShow: false,
      timer: null,
    }
  },
  watch: {
    show: {
      handler: function (val) {
        this.isShow = val
        this.dealBackHome()
      },
      immediate: true
    },
  },
  methods: {
    dealBackHome() {
      if (!this.show) {
        return
      }
      if (!this.success) {
        return
      }
      this.countDown = 10
      console.log('beforeUpdate')

      this.timer = setInterval(() => {
        this.countDown--
        if (this.countDown === 0) {
          this.dialogClose()
          this.$router.push({name: this.myPath.home})
          clearInterval(this.timer)
        }
      }, 1000)

    },
    dialogClose() {
      this.$emit('dialogClose', false)
    },
    handleClose(done) {
      if (!this.success) {
        done()
      }
    },

    clickBackHome() {
      this.dialogClose()
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.$router.push({name: this.myPath.home})
    },

    doReprintData() {
      this.rePrintData()
      if (this.timer) {
        clearInterval(this.timer)
      }
    }
  }
}
</script>

<style scoped lang="less">
.notify-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 22, 18, 0.5);
  // 低于 el-dialog__wrapper（PopupManager 分配 2000+）：点击落到 wrapper，
  // 走 el-dialog 自身的点遮罩关闭逻辑（失败可关、成功不误关）
  z-index: 1999;
}

.dialog-sign {
  display: flex;
  //height: 50vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>
